import React from 'react';
import { Link } from 'react-router-dom';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import '../projects/ProjectPage.css';
import './ResearchDetailPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2012-06-09', displayDate: 'June 9, 2012' };

const DISSERTATION_EMBED_URL =
  'https://docs.google.com/a/bikfalvi.com/file/d/0ByT4N8kjyuzXOExZZ0lWbmc2LXM/preview';

const PhdDissertationPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  return (
    <div className="project-page research-detail-page" id="top">
      <h1 className="title">Peer-to-Peer Television for the IP Multimedia Subsystem</h1>
      <p>
        <Link to="/research/phd">← Back to defense page</Link>
      </p>
      <div className="embed-container">
        <iframe
          src={DISSERTATION_EMBED_URL}
          title="Peer-to-Peer Television for the IP Multimedia Subsystem - Dissertation"
        />
      </div>
      <p className="update">Last updated: June 9, 2012</p>
    </div>
  );
};

export default PhdDissertationPage;
